import { colors } from "./colors";

// This is a Material-UI custom theme. This theme can be accessed and used by any file.
// Using a custom theme enables a consistent theme for reocurring components
// customTheme depends on the "theme" key and will use difference colors depending on the theme

//theme = ['light', 'dark']
export const customTheme = (theme = "light") => ({
  palette: {
    type: "dark",
    primary: {
      main: colors[theme].primary,
      light: colors[theme].primaryLight,
    },
    secondary: {
      main: colors[theme].secondary,
      light: colors[theme].secondaryLight,
    },
    error: {
      main: colors.warning,
    },
    background: {
      paper: colors[theme].bkg1,
    },
  },
  typography: {
    h1: {
      fontWeight: 600,
      fontSize: "2.5rem",
    },
  },

  // This is global overried for Materila-UI components.  Define the toolTip style for the entire app
  overrides: {
    MuiTooltip: {
      tooltip: {
        fontSize: "1rem",
        color: "white",
        backgroundColor:
          theme === "light" ? "rgba(0, 0, 0, 0.5)" : "rgba(0, 0, 0, 0.95)",
      },
    },
    MuiButton: {
      root: {
        fontSize: "0.875rem",
        fontWeight: "400",
      },
    },
    MuiIconButton: {
      root: {
        "&:hover": {
          backgroundColor: "unset",
        },
      },
    },
  },

  // Named styles. These styles can be imported to any JS file to be re-used.
  dialog: {
    // Dialog style shared by each dialog in the app
    root: {
      backgroundColor: colors[theme].dialogBkg,
      display: "flex",
      flex: "0 0 auto",
      minWidth: "650px",
      alignItems: "center",
      flexDirection: "column",
      padding: "25px",
      boxShadow:
        theme === "light"
          ? `0px 11px 15px -7px ${colors[theme].boxShadowColor},0.2), 0px 24px 38px 3px ${colors[theme].boxShadowColor},0.14), 0px 9px 46px 8px ${colors[theme].boxShadowColor},0.12)`
          : `${colors[theme].boxShadowColor}, 0.2) 0px 0px 14px 10px`,
    },
    title: {
      fontSize: "2.0rem",
      paddingBottom: "25px",
      "& span": {
        verticalAlign: "middle",
      },
    },
    contentContainer: {
      display: "flex",
      width: "80%",
      alignItems: "flex-start",
      flexDirection: "column",
    },
    contentItem: {
      margin: "10px",
    },
    contentItemPadding: {
      margin: "10px",
      paddingLeft: "10px",
    },
    buttonContainer: {
      minWidth: "100%",
      paddingTop: "25px",
      justifyContent: "space-evenly",
    },
  },
  card: {
    // Card style
    root: {
      padding: "20px",
      backgroundColor: colors[theme].cardBkg,
      boxShadow:
        theme === "light"
          ? `${colors[theme].boxShadowColor}, 0.2) 0px 0px 9px 4px`
          : `${colors[theme].boxShadowColor}, 0.2) 0px 0px 6px 2px`,
    },
    title: {
      paddingBottom: "10px",
    },
    contentItem: {
      width: "95%",
      margin: "10px",
    },
    buttonContainer: {
      display: "flex",
      minWidth: "100%",
      paddingTop: "25px",
      justifyContent: "space-evenly",
    },
  },

  buttonProgress: {
    color: colors[theme].primary,
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12,
  },

  buttonPrimary: {
    "&:hover": {
      backgroundColor: colors[theme].primaryLight,
    },
  },

  buttonSecondary: {
    "&:hover": {
      backgroundColor: colors[theme].secondaryLight,
    },
  },

  buttonOutlined: {
    color: theme === "dark" ? colors[theme].primary : "unset",
    "&:hover": {
      color: colors[theme].primaryLight,
    },
  },

  buttonOutlinedSecondary: {
    color: theme === "dark" ? colors[theme].secondary : "unset",
    "&:hover": {
      color: colors[theme].secondaryLight,
    },
  },

  iconButton: {
    padding: "0px",
    width: "36px",
    height: "36px",
    backgroundColor: colors.iconButtonColor, //colors[theme].bkg2,
    "&:hover": {
      backgroundColor: colors.iconButtonHoverColor, //colors[theme].keyboardColor,
    },
    "&.MuiIconButton-root": {
      color: colors[theme].iconButtonIconColor,
    },
    "&.Mui-disabled": {
      "&.MuiIconButton-root": {
        color: colors.disabledColor,
      },
      backgroundColor: colors.iconButtonDisabledColor,
    },
  },

  collapseButton: {
    padding: "0px",
    "&:hover": {
      backgroundColor: colors.collapseButtonHover,
    },
  },
  formText: {
    fontSize: 15,
  },
  triangle: {
    width: 0,
    height: 0,
    borderStyle: "solid",
    borderWidth: "20px 20px 20px 0",
    position: "absolute",
    right: 0,
    zIndex: 1,
    transform: "translateY(-50%)",
    transition: "top 0.5s ease",
  },
  tabTitle: {
    fontSize: "1.1rem",
    fontWeight: 500,
  },
  icon: {
    marginRight: "10px",
  },
  titleIcon: {
    marginRight: "10px",
    fontSize: "2rem",
    verticalAlign: "middle",
  },
  // iconSmall: {
  //   fontSize: "1.5rem",
  // },
  iconMedium: {
    fontSize: "2rem",
  },
  iconLarge: {
    fontSize: "2.5rem",
  },
  copyright: {
    margin: "10px 10px 5px 10px",
  },
  customScrollBar: {
    "&::-webkit-scrollbar": {
      width: "9px",
    },
    // "&::-webkit-scrollbar-track": {
    //   boxShadow: `inset 0 0 6px ${
    //     theme === "light" ? "rgba(0,0,0,0.4)" : "rgba(255,255,255,0.2)"
    //   }`,
    // },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor:
        theme === "light" ? "rgba(0,0,0,.3)" : "rgba(255,255,255,.2)",
      outline: "1px solid grey",
      borderRadius: "9px",
    },
  },
});
